import { type TFunction } from 'i18next'
import { type QuestionMeta } from '#types/form/wizard.ts'

export const personalChallengesTree = (t: TFunction): QuestionMeta => {
	return {
		id: 'personalChallenges',
		type: 'REGULAR_QUESTION_TREE',
		leadsToPhase: 'determineSupportType',
		questions: {
			A1: {
				text: t('personalChallenges.mainQuestion'),
				type: 'radio',
				id: 'personal-challenge',
				options: [
					{
						id: `question=${t('personalChallenges.mainQuestion')}&answer=${t(
							'personalChallenges.options.a1.text',
						)}`,
						text: t('personalChallenges.options.a1.text'),
						nextQuestionId: 'A1-A1',
					},
					{
						id: `question=${t('personalChallenges.mainQuestion')}&answer=${t(
							'personalChallenges.options.b1.text',
						)}`,
						text: t('personalChallenges.options.b1.text'),
						nextQuestionId: 'B1-A1',
					},
					{
						id: `question=${t('personalChallenges.mainQuestion')}&answer=${t(
							'personalChallenges.options.c1.text',
						)}`,
						text: t('personalChallenges.options.c1.text'),
						nextQuestionId: 'C1-A1',
					},
					{
						id: `question=${t('personalChallenges.mainQuestion')}&answer=${t(
							'personalChallenges.options.d1.text',
						)}`,
						text: t('personalChallenges.options.d1.text'),
						nextQuestionId: 'D1-A1',
					},
					{
						id: `question=${t('personalChallenges.mainQuestion')}&answer=${t(
							'personalChallenges.options.e1.text',
						)}`,
						text: t('personalChallenges.options.e1.text'),
						nextQuestionId: 'E1-A1',
					},
					{
						id: `question=${t('personalChallenges.mainQuestion')}&answer=${t(
							'personalChallenges.options.f1.text',
						)}`,
						text: t('personalChallenges.options.f1.text'),
						nextQuestionId: 'F1-A1',
					},
					{
						id: `question=${t('personalChallenges.mainQuestion')}&answer=${t(
							'personalChallenges.options.g1.text',
						)}`,
						text: t('personalChallenges.options.g1.text'),
						nextQuestionId: 'G1-A1',
					},
					{
						id: `question=${t('personalChallenges.mainQuestion')}&answer=${t(
							'personalChallenges.options.h1.text',
						)}`,
						text: t('personalChallenges.options.h1.text'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'A1-A1': {
				text: t('personalChallenges.options.a1.question'),
				type: 'radio',
				id: 'a1-trigger',
				options: [
					{
						id: `question=${t(
							'personalChallenges.options.a1.question',
						)}&answer=${t('personalChallenges.options.a1.options.a1-a1')}`,
						text: t('personalChallenges.options.a1.options.a1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.a1.question',
						)}&answer=${t('personalChallenges.options.a1.options.a1-b1')}`,
						text: t('personalChallenges.options.a1.options.a1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.a1.question',
						)}&answer=${t('personalChallenges.options.a1.options.a1-c1')}`,
						text: t('personalChallenges.options.a1.options.a1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.a1.question',
						)}&answer=${t('personalChallenges.options.a1.options.a1-d1')}`,
						text: t('personalChallenges.options.a1.options.a1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.a1.question',
						)}&answer=${t('personalChallenges.options.a1.options.a1-e1')}`,
						text: t('personalChallenges.options.a1.options.a1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.a1.question',
						)}&answer=${t('personalChallenges.options.a1.options.a1-f1')}`,
						text: t('personalChallenges.options.a1.options.a1-f1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'B1-A1': {
				text: t('personalChallenges.options.b1.question'),
				type: 'radio',
				id: 'b1-issue',
				options: [
					{
						id: `question=${t(
							'personalChallenges.options.b1.question',
						)}&answer=${t('personalChallenges.options.b1.options.b1-a1')}`,
						text: t('personalChallenges.options.b1.options.b1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.b1.question',
						)}&answer=${t('personalChallenges.options.b1.options.b1-b1')}`,
						text: t('personalChallenges.options.b1.options.b1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.b1.question',
						)}&answer=${t('personalChallenges.options.b1.options.b1-c1')}`,
						text: t('personalChallenges.options.b1.options.b1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.b1.question',
						)}&answer=${t('personalChallenges.options.b1.options.b1-d1')}`,
						text: t('personalChallenges.options.b1.options.b1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.b1.question',
						)}&answer=${t('personalChallenges.options.b1.options.b1-e1')}`,
						text: t('personalChallenges.options.b1.options.b1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.b1.question',
						)}&answer=${t('personalChallenges.options.b1.options.b1-f1')}`,
						text: t('personalChallenges.options.b1.options.b1-f1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'C1-A1': {
				text: t('personalChallenges.options.c1.question'),
				type: 'radio',
				id: 'c1-trigger',
				options: [
					{
						id: `question=${t(
							'personalChallenges.options.c1.question',
						)}&answer=${t('personalChallenges.options.c1.options.c1-a1')}`,
						text: t('personalChallenges.options.c1.options.c1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.c1.question',
						)}&answer=${t('personalChallenges.options.c1.options.c1-b1')}`,
						text: t('personalChallenges.options.c1.options.c1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.c1.question',
						)}&answer=${t('personalChallenges.options.c1.options.c1-c1')}`,
						text: t('personalChallenges.options.c1.options.c1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.c1.question',
						)}&answer=${t('personalChallenges.options.c1.options.c1-d1')}`,
						text: t('personalChallenges.options.c1.options.c1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.c1.question',
						)}&answer=${t('personalChallenges.options.c1.options.c1-e1')}`,
						text: t('personalChallenges.options.c1.options.c1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.c1.question',
						)}&answer=${t('personalChallenges.options.c1.options.c1-f1')}`,
						text: t('personalChallenges.options.c1.options.c1-f1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'D1-A1': {
				text: t('personalChallenges.options.d1.question'),
				type: 'radio',
				id: 'd1-trigger',
				options: [
					{
						id: `question=${t(
							'personalChallenges.options.d1.question',
						)}&answer=${t('personalChallenges.options.d1.options.d1-a1')}`,
						text: t('personalChallenges.options.d1.options.d1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.d1.question',
						)}&answer=${t('personalChallenges.options.d1.options.d1-b1')}`,
						text: t('personalChallenges.options.d1.options.d1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.d1.question',
						)}&answer=${t('personalChallenges.options.d1.options.d1-c1')}`,
						text: t('personalChallenges.options.d1.options.d1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.d1.question',
						)}&answer=${t('personalChallenges.options.d1.options.d1-d1')}`,
						text: t('personalChallenges.options.d1.options.d1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.d1.question',
						)}&answer=${t('personalChallenges.options.d1.options.d1-e1')}`,
						text: t('personalChallenges.options.d1.options.d1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.d1.question',
						)}&answer=${t('personalChallenges.options.d1.options.d1-f1')}`,
						text: t('personalChallenges.options.d1.options.d1-f1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'E1-A1': {
				text: t('personalChallenges.options.e1.question'),
				type: 'radio',
				id: 'e1-trigger',
				options: [
					{
						id: `question=${t(
							'personalChallenges.options.e1.question',
						)}&answer=${t('personalChallenges.options.e1.options.e1-a1')}`,
						text: t('personalChallenges.options.e1.options.e1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.e1.question',
						)}&answer=${t('personalChallenges.options.e1.options.e1-b1')}`,
						text: t('personalChallenges.options.e1.options.e1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.e1.question',
						)}&answer=${t('personalChallenges.options.e1.options.e1-c1')}`,
						text: t('personalChallenges.options.e1.options.e1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.e1.question',
						)}&answer=${t('personalChallenges.options.e1.options.e1-d1')}`,
						text: t('personalChallenges.options.e1.options.e1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.e1.question',
						)}&answer=${t('personalChallenges.options.e1.options.e1-e1')}`,
						text: t('personalChallenges.options.e1.options.e1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.e1.question',
						)}&answer=${t('personalChallenges.options.e1.options.e1-f1')}`,
						text: t('personalChallenges.options.e1.options.e1-f1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'F1-A1': {
				text: t('personalChallenges.options.f1.question'),
				type: 'radio',
				id: 'f1-trigger',
				options: [
					{
						id: `question=${t(
							'personalChallenges.options.f1.question',
						)}&answer=${t('personalChallenges.options.f1.options.f1-a1')}`,
						text: t('personalChallenges.options.f1.options.f1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.f1.question',
						)}&answer=${t('personalChallenges.options.f1.options.f1-b1')}`,
						text: t('personalChallenges.options.f1.options.f1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.f1.question',
						)}&answer=${t('personalChallenges.options.f1.options.f1-c1')}`,
						text: t('personalChallenges.options.f1.options.f1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.f1.question',
						)}&answer=${t('personalChallenges.options.f1.options.f1-d1')}`,
						text: t('personalChallenges.options.f1.options.f1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.f1.question',
						)}&answer=${t('personalChallenges.options.f1.options.f1-e1')}`,
						text: t('personalChallenges.options.f1.options.f1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.f1.question',
						)}&answer=${t('personalChallenges.options.f1.options.f1-f1')}`,
						text: t('personalChallenges.options.f1.options.f1-f1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'G1-A1': {
				text: t('personalChallenges.options.g1.question'),
				type: 'radio',
				id: 'g1-trigger',
				options: [
					{
						id: `question=${t(
							'personalChallenges.options.g1.question',
						)}&answer=${t('personalChallenges.options.g1.options.g1-a1')}`,
						text: t('personalChallenges.options.g1.options.g1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.g1.question',
						)}&answer=${t('personalChallenges.options.g1.options.g1-b1')}`,
						text: t('personalChallenges.options.g1.options.g1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.g1.question',
						)}&answer=${t('personalChallenges.options.g1.options.g1-c1')}`,
						text: t('personalChallenges.options.g1.options.g1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.g1.question',
						)}&answer=${t('personalChallenges.options.g1.options.g1-d1')}`,
						text: t('personalChallenges.options.g1.options.g1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.g1.question',
						)}&answer=${t('personalChallenges.options.g1.options.g1-e1')}`,
						text: t('personalChallenges.options.g1.options.g1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'personalChallenges.options.g1.question',
						)}&answer=${t('personalChallenges.options.g1.options.g1-f1')}`,
						text: t('personalChallenges.options.g1.options.g1-f1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			SupportQuestion: {
				text: t('personalChallenges.supportQuestion'),
				type: 'radio',
				id: 'support-question',
				options: [
					{
						id: `question=${t('personalChallenges.question')}&answer=${t(
							'personalChallenges.supportOptions.practicalSteps',
						)}`,
						text: t('personalChallenges.supportOptions.practicalSteps'),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t('personalChallenges.question')}&answer=${t(
							'personalChallenges.supportOptions.understandingInsight',
						)}`,
						text: t('personalChallenges.supportOptions.understandingInsight'),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t('personalChallenges.question')}&answer=${t(
							'personalChallenges.supportOptions.encouragementMotivation',
						)}`,
						text: t(
							'personalChallenges.supportOptions.encouragementMotivation',
						),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t('personalChallenges.question')}&answer=${t(
							'personalChallenges.supportOptions.resourcesTools',
						)}`,
						text: t('personalChallenges.supportOptions.resourcesTools'),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t('personalChallenges.question')}&answer=${t(
							'personalChallenges.supportOptions.listeningEar',
						)}`,
						text: t('personalChallenges.supportOptions.listeningEar'),
						nextQuestionId: 'END',
					},
				],
			},
		},
	}
}

export const interpersonalChallengesTree = (t: TFunction): QuestionMeta => {
	return {
		id: 'interpersonalChallenges',
		type: 'REGULAR_QUESTION_TREE',
		leadsToPhase: 'determineSupportType',
		questions: {
			A1: {
				text: t('interpersonalChallenges.mainQuestion'),
				type: 'radio',
				id: 'interpersonal-main',
				options: [
					{
						id: `question=${t(
							'interpersonalChallenges.mainQuestion',
						)}&answer=${t('interpersonalChallenges.options.a1.text')}`,
						text: t('interpersonalChallenges.options.a1.text'),
						nextQuestionId: 'A1-A1',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.mainQuestion',
						)}&answer=${t('interpersonalChallenges.options.b1.text')}`,
						text: t('interpersonalChallenges.options.b1.text'),
						nextQuestionId: 'A1-B1',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.mainQuestion',
						)}&answer=${t('interpersonalChallenges.options.c1.text')}`,
						text: t('interpersonalChallenges.options.c1.text'),
						nextQuestionId: 'A1-C1',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.mainQuestion',
						)}&answer=${t('interpersonalChallenges.options.d1.text')}`,
						text: t('interpersonalChallenges.options.d1.text'),
						nextQuestionId: 'A1-D1',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.mainQuestion',
						)}&answer=${t('interpersonalChallenges.options.e1.text')}`,
						text: t('interpersonalChallenges.options.e1.text'),
						nextQuestionId: 'A1-E1',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.mainQuestion',
						)}&answer=${t('interpersonalChallenges.options.f1.text')}`,
						text: t('interpersonalChallenges.options.f1.text'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'A1-A1': {
				text: t('interpersonalChallenges.options.a1.question'),
				type: 'radio',
				id: 'a1-partner',
				options: [
					{
						id: `question=${t(
							'interpersonalChallenges.options.a1.question',
						)}&answer=${t('interpersonalChallenges.options.a1.options.a1-a1')}`,
						text: t('interpersonalChallenges.options.a1.options.a1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.a1.question',
						)}&answer=${t('interpersonalChallenges.options.a1.options.a1-b1')}`,
						text: t('interpersonalChallenges.options.a1.options.a1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.a1.question',
						)}&answer=${t('interpersonalChallenges.options.a1.options.a1-c1')}`,
						text: t('interpersonalChallenges.options.a1.options.a1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.a1.question',
						)}&answer=${t('interpersonalChallenges.options.a1.options.a1-d1')}`,
						text: t('interpersonalChallenges.options.a1.options.a1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.a1.question',
						)}&answer=${t('interpersonalChallenges.options.a1.options.a1-e1')}`,
						text: t('interpersonalChallenges.options.a1.options.a1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'A1-B1': {
				text: t('interpersonalChallenges.options.b1.question'),
				type: 'radio',
				id: 'b1-family',
				options: [
					{
						id: `question=${t(
							'interpersonalChallenges.options.b1.question',
						)}&answer=${t('interpersonalChallenges.options.b1.options.b1-a1')}`,
						text: t('interpersonalChallenges.options.b1.options.b1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.b1.question',
						)}&answer=${t('interpersonalChallenges.options.b1.options.b1-b1')}`,
						text: t('interpersonalChallenges.options.b1.options.b1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.b1.question',
						)}&answer=${t('interpersonalChallenges.options.b1.options.b1-c1')}`,
						text: t('interpersonalChallenges.options.b1.options.b1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.b1.question',
						)}&answer=${t('interpersonalChallenges.options.b1.options.b1-d1')}`,
						text: t('interpersonalChallenges.options.b1.options.b1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.b1.question',
						)}&answer=${t('interpersonalChallenges.options.b1.options.b1-e1')}`,
						text: t('interpersonalChallenges.options.b1.options.b1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'A1-C1': {
				text: t('interpersonalChallenges.options.c1.question'),
				type: 'radio',
				id: 'c1-colleague',
				options: [
					{
						id: `question=${t(
							'interpersonalChallenges.options.c1.question',
						)}&answer=${t('interpersonalChallenges.options.c1.options.c1-a1')}`,
						text: t('interpersonalChallenges.options.c1.options.c1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.c1.question',
						)}&answer=${t('interpersonalChallenges.options.c1.options.c1-b1')}`,
						text: t('interpersonalChallenges.options.c1.options.c1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.c1.question',
						)}&answer=${t('interpersonalChallenges.options.c1.options.c1-c1')}`,
						text: t('interpersonalChallenges.options.c1.options.c1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.c1.question',
						)}&answer=${t('interpersonalChallenges.options.c1.options.c1-d1')}`,
						text: t('interpersonalChallenges.options.c1.options.c1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.c1.question',
						)}&answer=${t('interpersonalChallenges.options.c1.options.c1-e1')}`,
						text: t('interpersonalChallenges.options.c1.options.c1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'A1-D1': {
				text: t('interpersonalChallenges.options.d1.question'),
				type: 'radio',
				id: 'd1-friend',
				options: [
					{
						id: `question=${t(
							'interpersonalChallenges.options.d1.question',
						)}&answer=${t('interpersonalChallenges.options.d1.options.d1-a1')}`,
						text: t('interpersonalChallenges.options.d1.options.d1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.d1.question',
						)}&answer=${t('interpersonalChallenges.options.d1.options.d1-b1')}`,
						text: t('interpersonalChallenges.options.d1.options.d1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.d1.question',
						)}&answer=${t('interpersonalChallenges.options.d1.options.d1-c1')}`,
						text: t('interpersonalChallenges.options.d1.options.d1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.d1.question',
						)}&answer=${t('interpersonalChallenges.options.d1.options.d1-d1')}`,
						text: t('interpersonalChallenges.options.d1.options.d1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.d1.question',
						)}&answer=${t('interpersonalChallenges.options.d1.options.d1-e1')}`,
						text: t('interpersonalChallenges.options.d1.options.d1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			'A1-E1': {
				text: t('interpersonalChallenges.options.e1.question'),
				type: 'radio',
				id: 'e1-acquaintance',
				options: [
					{
						id: `question=${t(
							'interpersonalChallenges.options.e1.question',
						)}&answer=${t('interpersonalChallenges.options.e1.options.e1-a1')}`,
						text: t('interpersonalChallenges.options.e1.options.e1-a1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.e1.question',
						)}&answer=${t('interpersonalChallenges.options.e1.options.e1-b1')}`,
						text: t('interpersonalChallenges.options.e1.options.e1-b1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.e1.question',
						)}&answer=${t('interpersonalChallenges.options.e1.options.e1-c1')}`,
						text: t('interpersonalChallenges.options.e1.options.e1-c1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.e1.question',
						)}&answer=${t('interpersonalChallenges.options.e1.options.e1-d1')}`,
						text: t('interpersonalChallenges.options.e1.options.e1-d1'),
						nextQuestionId: 'SupportQuestion',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.options.e1.question',
						)}&answer=${t('interpersonalChallenges.options.e1.options.e1-e1')}`,
						text: t('interpersonalChallenges.options.e1.options.e1-e1'),
						nextQuestionId: 'SupportQuestion',
					},
				],
			},
			SupportQuestion: {
				text: t('interpersonalChallenges.supportQuestion'),
				type: 'radio',
				id: 'support-question-interpersonal',
				options: [
					{
						id: `question=${t(
							'interpersonalChallenges.supportQuestion',
						)}&answer=${t(
							'interpersonalChallenges.supportOptions.practicalCommunicationStrategies',
						)}`,
						text: t(
							'interpersonalChallenges.supportOptions.practicalCommunicationStrategies',
						),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.supportQuestion',
						)}&answer=${t(
							'interpersonalChallenges.supportOptions.understandingRelationshipDynamics',
						)}`,
						text: t(
							'interpersonalChallenges.supportOptions.understandingRelationshipDynamics',
						),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.supportQuestion',
						)}&answer=${t(
							'interpersonalChallenges.supportOptions.encouragementReassurance',
						)}`,
						text: t(
							'interpersonalChallenges.supportOptions.encouragementReassurance',
						),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.supportQuestion',
						)}&answer=${t(
							'interpersonalChallenges.supportOptions.guidanceOnSettingBoundaries',
						)}`,
						text: t(
							'interpersonalChallenges.supportOptions.guidanceOnSettingBoundaries',
						),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.supportQuestion',
						)}&answer=${t(
							'interpersonalChallenges.supportOptions.mediationAndConflictResolutionTools',
						)}`,
						text: t(
							'interpersonalChallenges.supportOptions.mediationAndConflictResolutionTools',
						),
						nextQuestionId: 'END',
					},
					{
						id: `question=${t(
							'interpersonalChallenges.supportQuestion',
						)}&answer=${t(
							'interpersonalChallenges.supportOptions.empatheticListening',
						)}`,
						text: t(
							'interpersonalChallenges.supportOptions.empatheticListening',
						),
						nextQuestionId: 'END',
					},
				],
			},
		},
	}
}
